import PageShell from "../components/ms/PageShell";

const IVORY = "#f3ead2";
const SLATE = "#a8aebd";
const SLATE_DIM = "#6f7587";
const GOLD = "#e9d6a2";
const GOLD_DEEP = "#bfa874";
const Serif = { fontFamily: "Fraunces, serif" };

const H3 = ({ children }) => (
  <h3
    className="mt-14 mb-5 leading-[1.15] tracking-[-0.012em]"
    style={{ ...Serif, color: IVORY, fontSize: "clamp(1.4rem, 2.3vw, 1.9rem)" }}
  >
    {children}
  </h3>
);

const P = ({ children }) => (
  <p className="mt-5 text-[16px] leading-[1.85]" style={{ color: SLATE }}>
    {children}
  </p>
);

const List = ({ items }) => (
  <ul className="mt-5 space-y-3">
    {items.map((it, i) => (
      <li key={i} className="grid grid-cols-[24px_1fr] gap-3 text-[15.5px] leading-[1.7]" style={{ color: SLATE }}>
        <span style={{ color: GOLD }}>·</span>
        <span>{it}</span>
      </li>
    ))}
  </ul>
);

export default function LegalPage({ title, kicker, effectiveDate, children }) {
  return (
    <PageShell testId="legal-page">
      <div className="max-w-4xl mx-auto px-6 md:px-10 pt-20 md:pt-32 pb-24" style={{ color: IVORY }}>
        <p className="text-[10.5px] tracking-[0.4em] uppercase" style={{ color: GOLD_DEEP }}>
          {kicker}
        </p>
        <h1
          className="mt-6 leading-[0.98] tracking-[-0.022em]"
          style={{ ...Serif, color: IVORY, fontSize: "clamp(2.25rem, 4.4vw, 4rem)" }}
          data-testid="legal-title"
        >
          {title}
        </h1>
        <p className="mt-6 text-[11px] tracking-[0.32em] uppercase" style={{ color: SLATE_DIM }}>
          Effective {effectiveDate}
        </p>
        <div
          aria-hidden
          className="mt-10"
          style={{
            height: 1,
            width: 96,
            background: `linear-gradient(90deg, ${GOLD_DEEP}, transparent)`,
          }}
        />
        <div className="mt-10">{children}</div>
      </div>
    </PageShell>
  );
}

/* Re-exports for convenience */
export { H3, P, List };
